<template>
  <div class="form-row d-info d-frame">
    <h3>Kod podarunkowy Allegro <span v-if="amount">o wartości {{ amount }} zł</span></h3>
    <p>Kod podarunkowy Allegro to idealny prezent na każdą okazję! Kod można wykorzystać przy płatności z góry za zakupy dowolnych produktów dostępnych na platformie allegro.pl. A jest z czego wybierać. Każdego dnia już ponad 100 milinów ofert czeka na swoich klientów.</p>
    <p><a href="" @click.prevent="showMore = true" v-if="!showMore">więcej informacji</a></p>
    <div v-if="showMore">
      <h3>Jak wykorzystasz Kod?</h3>
      <ul class="decimal pushed">
        <li>
          <p>Na stronie allegro.pl:</p>
          <ul>
            <li>Zrób zakupy i wybierz płatność z góry</li>
            <li>Zaznacz opcję „Masz kod lub kartę podarunkową?”</li>
            <li>Wpisz kod i kliknij „Zatwierdź”</li>
            <li>Kwota do zapłaty zostanie obniżona o wartość Kodu</li>
          </ul>
        </li>
        <li>
          <p>W aplikacji mobilnej Allegro:</p>
          <ul>
            <li>Otwórz menu lub „Moje Allegro” w aplikacji</li>
            <li>Przejdź do zakładki „Monety i kupony” i otwórz „Kupony”</li>
            <li>Wpisz kod i odbierz kupon</li>
            <li>Zrób zakupy i wybierz płatność z góry</li>
            <li>Zaznacz kupon – kwota do zapłaty obniży się o jego wartość</li>
          </ul>
        </li>
      </ul>
      <h3>Zasady i warunki wykorzystania:</h3>
      <ul>
        <li>Kod obejmuje wszystkie dostępne na platformie produkty. Wykorzystasz go przed finalizacją transakcji niezależnie od rodzaju zakupu (Kup Teraz, zakupy przez koszyk, licytacje)</li>
        <li>Kod możesz wykorzystać na stronie allegro.pl oraz w aplikacji mobilnej Allegro</li>
        <li>W jednej płatności możesz wykorzystać tylko jeden kod, przy czym płatność może obejmować zakupy wielu produktów od wielu sprzedających</li>
        <li>Kod możesz wykorzystać tylko jeden raz. Jeżeli wartość płatności jest niższa, niż wartość nominalna Kodu, nie wydajemy reszty w gotówce. Pozostała wartość Kodu nie może zostać wykorzystana w okresie jej ważności i nie podlega zwrotowi</li>
        <li>kod możesz wykorzystać również przy zakupach w trybie „gość” (bez zarejestrowanego konta)</li>
        <li>Płatność z wykorzystaniem kodu nie obejmuje kosztów przesyłki, które będziesz musiał opłacić z wykorzystaniem dostępnych metod płatności</li>
        <li>Nie będziesz mógł wykorzystać kodu, jeśli jako metodę płatności wybierzesz jeden z produktów ratalnych, kredytowych lub płatność przy odbiorze</li>
        <li>Kod nie podlega wymianie na środki pieniężne w całości lub w części</li>
        <li>Wszystkie informacje dotyczące wykorzystania Kart podarunkowych na platformie Allegro dostępne są na <a href="https://allegro.pl/karty-podarunkowe" target="_blank" rel="nofollow">stronie informacyjnej</a> oraz w <a href="https://allegro.pl/regulaminy/regulamin-kart-podarunkowych-serwisu-allegro-4GDAboO2OFR" target="_blank" rel="nofollow">regulaminie</a></li>
      </ul>
      <p>Wydawcą Kart podarunkowych Allegro jest Allegro.pl sp. z o.o. z siedzibą w Poznaniu.</p>
      <p><a href="" @click.prevent="showMore = false">zwiń</a></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopupCodesInfoAllegro',
  props: ['amount'],
  data () {
    return {
      showMore: false
    }
  }
}
</script>
